'use strict';
/**
 * This directive emits a dom:ready when the digest cycle is complete
 * for a scope See look.html in lookbook for a reference
 */

module.exports = /*@ngInject*/

function() {
   return {
     scope: true,
     link: function(scope, element) {
        if (scope.$last) {
            scope.$emit('dom:ready');
        }
     }
   };
};
